<template>
  <div class="data_body">
    <div style="width: 100%;height: calc(100% - 30px); margin-top: 15px;overflow: auto;">
      <el-table :data="tableData" style="width: 100%" height="100%" :header-cell-style="{ background: '#E0EAFB',color: '#000' }"
        :row-class-name="tableRowClassName" class="tableClass">
        <el-table-column label="排名" min-width="50" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="title" label="课程名称" min-width="80" align="center">
        </el-table-column>
        <el-table-column prop="compare" label="较上周" min-width="80" align="center">
					<template slot-scope="scope">
						<div>
							<!-- {{ Math.abs(scope.row.compare) }} -->
							<div v-if="scope.row.compare>0" class="el-icon-top compareDown">{{ Math.abs(scope.row.compare) }}</div>
							<div v-if="scope.row.compare==0">-</div>
							<div v-if="scope.row.compare<0" class="el-icon-bottom compareUp">{{ Math.abs(scope.row.compare) }}</div>
						</div>
					</template>
        </el-table-column>
        <el-table-column prop="total" label="上课人次" min-width="80" align="center">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rankData: {
      type: Array,
    },
  },
  data() {
    return {
      tableData: [],
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "even_row";
      } else {
        return "";
      }
    },
    setArray(array){
      this.tableData = JSON.parse(JSON.stringify(array))
      this.tableData = this.tableData.sort(function(a,b){
        return b.total - a.total;
      })
    }
  },
  watch: {
    rankData: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.setArray(newValue)
        this.$forceUpdate();
      },
    },
  },
  mounted() {
    this.setArray(this.rankData)
  },
};
</script>

<style scoped>
.el-table>>>.even_row {
  background-color: #f2f7ff !important;
}

.data_body {
  height: 100%;
  /* display: flex; */
  position: relative;
  border-radius: 5px;
  /* border: 1px solid #eee; */
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0;
  width: 95%;
  /* background: #fff; */
}

.tableClass >>> td, .tableClass >>> th{
  padding: 5px 0;
}

.data_body div::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 6px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 6px;
}

/*定义滚动条轨道 内阴影+圆角*/
.data_body div::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #fff;
}

/*定义滑块 内阴影+圆角*/
.data_body div::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px #AECCFE;
    background-color: #AECCFE;
}

.compareUp{
	color: #17C469;
  background: #effcf5;
  padding: 5px 10px;
	letter-spacing: 5px;
	border-radius: 3px;
}

.compareDown{
	color: #EE3E3E;
	background-color: #FFDDDD;
	padding: 5px 10px;
	letter-spacing: 5px;
	border-radius: 3px;
}

</style>


// WEBPACK FOOTER //
// src/components/pages/sz/dataBoardArea/dataCenter/chartList/courseRank/index.vue